// Number formatting for the George conversation and artifact cards.
// Figures always come from the platform; these helpers only display them.

const isNum = (n) => typeof n === 'number' && Number.isFinite(n);

// $2,500,000 -> "$2.5M", $420,000 -> "$420K", $950 -> "$950"
export function compactMoney(value) {
  if (!isNum(value)) return '—';
  const sign = value < 0 ? '−' : '';
  const abs = Math.abs(value);
  if (abs >= 1_000_000) {
    const m = abs / 1_000_000;
    return `${sign}$${m >= 10 ? Math.round(m) : m.toFixed(m % 1 === 0 ? 0 : 2).replace(/0$/, '')}M`;
  }
  if (abs >= 1_000) return `${sign}$${Math.round(abs / 1_000)}K`;
  return `${sign}$${Math.round(abs)}`;
}

export function fullMoney(value) {
  if (!isNum(value)) return '—';
  return `${value < 0 ? '−' : ''}$${Math.round(Math.abs(value)).toLocaleString('en-US')}`;
}

export function centsToDollars(cents) {
  return isNum(cents) ? cents / 100 : null;
}

export function pct(value) {
  return isNum(value) ? `${Math.round(value)}%` : '—';
}

export function shortDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function monthName(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-US', { month: 'long' });
}
